import DoctorAccordionDetails from './doctor-accordion';
import DoctorItemSkeleton from './doctor-item-skeleton';

export {
  DoctorAccordionDetails,
  DoctorItemSkeleton,
};
